import { useEffect, useState } from "react";
import logo from "../../assets/images/logo/BannerISFsmall.png";
/* import Language from "../Language"; */
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { FaUserPlus } from "react-icons/fa";
import { UseAuth } from "src/auth/AuthContext";
import APIService from "src/services/Api";
import { IoMdClose } from "react-icons/io";
import { ImMenu } from "react-icons/im";
import { MdDashboard } from "react-icons/md";
import { HiUser, HiSparkles, HiBars3, HiXMark, HiArrowRightOnRectangle } from "react-icons/hi2";
import DialogInfoGeneral from "../Shared/DialogInfoGeneral";
import RegisterPreForm from "../Register/RegisterPreForm";
import { useAppStateContext } from "src/auth/AppStateContext";
import { getProfileDefaultImage } from "src/helpers/mixins";

const Navbar = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { isAuthenticated, user } = UseAuth();
  const [showMovil, setShowMovil] = useState<boolean>(false);
  const { showRegisterPopup, setShowRegisterPopup,setGoLogin } = useAppStateContext();
  const navigate = useNavigate();
  const [showJoinUs, setShowJoinUs] = useState<boolean>(false);
  useEffect(() => {
    APIService.getToken();
  }, []);

  const { apodo } = useParams();

  const handleLogin = () => {
    if(!apodo && pathname !== '/'){
      navigate('/')
    }else{
      setGoLogin(true)
    }
  }
  const handleVisit = (link: string) => {
    setShowMovil(false);
    if (link !== "/register") {
      navigate(link);
    } else {
      setShowRegisterPopup(true);
    }
  };
  useEffect(() => {
    if (!pathname.includes("/referido/")) {
      setShowJoinUs(true);
    } else {
      setShowJoinUs(false);
    }
  }, [pathname]);

  return (
    <div>
      <nav
        className="bg-white fixed top-0 left-0 right-0 w-full border-b border-gray-200 shadow-sm"
        style={{ zIndex: "1000" }}
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            <Link to="/inicio" className="flex items-center flex-shrink-0">
              <img alt="icon" className="h-8 sm:h-10 md:h-12 w-auto" src={logo} />
            </Link>
            
            {/* Mobile Menu Button */}
            <button
              onClick={() => setShowMovil(!showMovil)}
              type="button"
              className="xl:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 hover:text-emerald-600 transition-colors"
              aria-controls="mobile-menu"
              aria-expanded={showMovil}
            >
              {!showMovil ? (
                <HiBars3 size={24} />
              ) : (
                <HiXMark size={24} />
              )}
            </button>

            {/* Desktop Menu */}
            <div className="hidden xl:flex items-center gap-2">
              <ul className="flex items-center gap-1">
                {isAuthenticated && (
                  <li>
                    <Link to="/inicio">
                      <div className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors">
                        <div
                          className="w-8 h-8 bg-cover bg-center rounded-full border-2 border-gray-200"
                          style={{
                            backgroundImage: `url(${
                              (user?.photoUrl?.length || 0) > 0
                                ? process.env.REACT_APP_PROFILEPICTURE +
                                  (user?.photoUrl || "")
                                : getProfileDefaultImage()
                            })`,
                          }}
                        ></div>
                        <span className="font-medium text-gray-700 text-sm">
                          {user?.fullname?.split(" ")[0]}
                        </span>
                      </div>
                    </Link>
                  </li>
                )}
                <li>
                  <Link to="/academia">
                    <button className="px-4 py-2 text-gray-700 hover:text-emerald-600 font-medium rounded-lg hover:bg-gray-50 transition-all duration-200">
                      {t("academytext")}
                    </button>
                  </Link>
                </li>
                <li>
                  <Link to="/videos">
                    <button className="px-4 py-2 text-gray-700 hover:text-emerald-600 font-medium rounded-lg hover:bg-gray-50 transition-all duration-200">
                      Videos
                    </button>
                  </Link>
                </li>
                <li>
                  <Link to="/blog">
                    <button className="px-4 py-2 text-gray-700 hover:text-emerald-600 font-medium rounded-lg hover:bg-gray-50 transition-all duration-200">
                      {t("blogtext")}
                    </button>
                  </Link>
                </li>
                <li>
                  <Link to="/quienes-somos">
                    <button className="px-4 py-2 text-gray-700 hover:text-emerald-600 font-medium rounded-lg hover:bg-gray-50 transition-all duration-200">
                      {t("aboutus")}
                    </button>
                  </Link>
                </li>
              </ul>
              {!isAuthenticated && (
                <div className="flex items-center gap-3 ml-4">
                  <button 
                    onClick={() => handleLogin()} 
                    className="flex items-center gap-2 px-4 py-2 text-gray-700 font-medium border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
                  >
                    <HiArrowRightOnRectangle size={18} />
                    {t("login")}
                  </button>
                  {showJoinUs && (
                    <button
                      onClick={() => setShowRegisterPopup(true)}
                      className="flex items-center gap-2 px-5 py-2 bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105"
                    >
                      <HiSparkles size={18} />
                      {t("join")}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      <DialogInfoGeneral
        disabledFooter={true}
        size={"xl"}
        show={showRegisterPopup}
        closeDialog={() => setShowRegisterPopup(false)}
        children={<RegisterPreForm />}
      />
      {/* Mobile Menu */}
      {showMovil && (
        <div className="fixed inset-0 top-16 bg-white z-[999] overflow-y-auto">
          <div className="container mx-auto px-4 py-6">
            {!isAuthenticated ? (
              <div className="mb-6">
                <div onClick={() => handleVisit("/")}>
                  <button className="w-full font-medium text-gray-700 rounded-xl flex items-center justify-center gap-3 text-base cursor-pointer transition-all duration-200 px-4 py-3 shadow-sm bg-gradient-to-r from-gray-50 to-gray-100 hover:from-gray-100 hover:to-gray-200 border border-gray-200">
                    <MdDashboard className="text-emerald-600" size={20} />
                    <span className="font-semibold">{t("home")}</span>
                  </button>
                </div>
              </div>
            ) : (
              <div className="mb-6">
                <Link to="/inicio">
                  <div className="flex flex-col justify-center text-center items-center font-normal gap-3 p-6 bg-gradient-to-r from-emerald-50 to-emerald-100 rounded-xl border-2 border-emerald-200 shadow-md">
                    <div
                      className="w-16 h-16 bg-cover bg-center rounded-full border-3 border-emerald-500 shadow-lg"
                      style={{
                        backgroundImage: `url(${
                          (user?.photoUrl?.length || 0) > 0
                            ? process.env.REACT_APP_PROFILEPICTURE +
                              (user?.photoUrl || "")
                            : getProfileDefaultImage()
                        })`,
                      }}
                    ></div>
                    <div className="font-semibold">
                      <div className="text-emerald-600 text-sm mb-1">Sesión iniciada</div>
                      <div className="text-gray-800">{user?.fullname?.split(" ")[0]}</div>
                    </div>
                  </div>
                </Link>
              </div>
            )}

            {!isAuthenticated && (
              <div className="mb-6 space-y-3">
                <div onClick={() => handleVisit("/register")}>
                  <button className="w-full font-medium text-white rounded-xl flex items-center justify-center gap-3 text-base cursor-pointer transition-all duration-200 px-4 py-3 bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 shadow-md">
                    <FaUserPlus size={20} />
                    <span className="font-semibold">{t("register")}</span>
                  </button>
                </div>
              </div>
            )}

            <div className="space-y-2">
              <div onClick={() => handleVisit("/quienes-somos")}>
                <button className="w-full font-medium text-gray-700 rounded-lg flex items-center justify-start gap-3 text-base cursor-pointer transition-all duration-200 px-4 py-3 hover:bg-gray-50 border border-gray-200">
                  <span className="font-semibold">{t("aboutus")}</span>
                </button>
              </div>
              <div onClick={() => handleVisit("/academia")}>
                <button className="w-full font-medium text-gray-700 rounded-lg flex items-center justify-start gap-3 text-base cursor-pointer transition-all duration-200 px-4 py-3 hover:bg-gray-50 border border-gray-200">
                  <span className="font-semibold">{t("academytext")}</span>
                </button>
              </div>
              <div onClick={() => handleVisit("/videos")}>
                <button className="w-full font-medium text-gray-700 rounded-lg flex items-center justify-start gap-3 text-base cursor-pointer transition-all duration-200 px-4 py-3 hover:bg-gray-50 border border-gray-200">
                  <span className="font-semibold">Videos</span>
                </button>
              </div>
              <div onClick={() => handleVisit("/blog")}>
                <button className="w-full font-medium text-gray-700 rounded-lg flex items-center justify-start gap-3 text-base cursor-pointer transition-all duration-200 px-4 py-3 hover:bg-gray-50 border border-gray-200">
                  <span className="font-semibold">{t("blogtext")}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="mb-6 pb-7"></div>
    </div>
  );
};

export default Navbar;
